import Button from "@/common/components/Button";
import { CopyButton } from "@/common/components/CopyButton";
import Modal from "@/common/components/Modal";
import TextField from "@/common/components/TextField";
import { useCopyButton } from "@/common/hooks/useCopyButton";
import { useState } from "react";
import { useClientUserShowConsumptionPassword } from "../hooks/useClientUserShowConsumptionPassword";

const ShowConsumptionPassword = ({ id }: { id: string; }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { control, copySuccess } = useCopyButton();

  const { data: consumptionPassword } = useClientUserShowConsumptionPassword({
    userId: id,
    enabled: isOpen,
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onConfirm={() => setIsOpen(false)}
        dataTestid="confirm_consumption_password_button"
        Trigger={
          <Button name="show_consumption">
            Ver senha de consumo
          </Button>
        }
        footer="Entendido!"
        title="Esta é a senha de consumo do usuário"
        subtitleClassName="mt-1 font-light text-white-300"
        body={(
          <div className="flex flex-col gap-2 py-2">
            <TextField
              disabled
              label="senha de consumo"
              name="password_consumption"
              className="grow"
              RightIcon={<CopyButton control={control} className="text-blue-800" />}
              onIconClick={() => copySuccess(consumptionPassword?.consumption_password || '')}
              value={consumptionPassword?.consumption_password || ''}
            />
          </div>
        )}
      />
    </>
  );
};

export default ShowConsumptionPassword;
